import React, { ReactNode } from 'react';
import type { ListProps }   from '@mantine/core';
import { List }           from '@mantine/core';


interface Props extends ListProps {
    children: ReactNode;
}

// WE CAN HAVE SOME SANE DEFAULTS FOR THIS
export const CList: React.FC<Props> = (props) => {

    const { children, ...rest } = props;

    return (
        <List {...rest}>
            {children}
        </List>
    );

}
